<template>
  <div class="details activity-details-info" v-if="activityDetails">
    <b-row class="p-10 pt-20">
      <b-col cols="1"></b-col>
      <b-col cols="10">
        <div class="pt-15 card inner-card br-2">
          <div class="outer-activity-study">
            <div class="activity-detail-left">
              <div class="activity-left-sec">
                <div class="pl-20 pb-15">
                  <div class="activity-info mb-10 col">
                    Activity Information
                  </div>
                  <b-row>
                    <b-col cols="3" class="p-0">
                      {{ activityDetails.title }}
                    </b-col>
                  </b-row>
                </div>
              </div>
              <div class="pl-20 pb-15 activity-flex-details">
                <div v-if="activityDetails.therapeuticArea" class="col">
                  <div class="content">
                    Name
                  </div>
                  <div class="header">
                    {{ activityDetails.nickName }}
                  </div>
                </div>
                <div v-if="activityDetails.therapeuticArea" class="col">
                  <div class="content">
                    Author
                  </div>
                  <div class="header">
                    {{ activityDetails.author }}
                  </div>
                </div>
              </div>
              <div class="pl-20 pb-15 activity-flex-details">
                <div v-if="activityDetails.therapeuticArea" class="col">
                  <div class="content">
                    Abbreviation
                  </div>
                  <div class="header">
                    {{ activityDetails.abbreviation }}
                  </div>
                </div>
                <div v-if="activityDetails.therapeuticArea" class="col">
                  <div class="content">
                    Copyright
                  </div>
                  <div class="header">
                    {{ activityDetails.copyright }}
                  </div>
                </div>
              </div>
              <div class="pl-20 pb-15 activity-flex-details">
                <div class="pb-10 col" v-if="activityDetails.therapeuticArea">
                  <div class="content">
                    Therapeutic area
                  </div>
                  <div class="header">
                    {{ activityDetails.therapeuticArea }}
                  </div>
                </div>
                <div class="pb-10 col" v-if="activityDetails.therapeuticArea">
                  <div class="content">
                    <span v-for="(langIndex, index) in activityDetails.language" :key="index">{{ langIndex.name }},</span>
                  </div>
                  <div class="header">
                    {{ activityDetails.therapeuticArea }}
                  </div>
                </div>
              </div>
              <div class="pl-20 pb-15 activity-flex-details">
                <div class="pb-10 col" v-if="activityDetails.therapeuticIndication">
                  <div class="content">
                    Therapeutic indication
                  </div>
                  <div class="header">
                    {{ activityDetails.therapeuticIndication }}
                  </div>
                </div>
                <div class="pb-10 col" v-if="activityDetails.therapeuticIndication">
                  <div class="content">
                    Groups
                  </div>
                  <div class="header">
                    {{ activityDetails.groupName }}
                  </div>
                </div>
              </div>
              <div class="pl-20 pb-15 activity-flex-details">
                <div class="pb-10 col" v-if="activityDetails.therapeuticIndication">
                  <div class="content">
                    Permissions
                  </div>
                  <div class="header">
                    <p>
                      Completed By:<span v-for="(viewIndex, index) in activityDetails.completedBy" :key="index">{{ viewIndex }},</span>
                    </p>
                  </div>
                  <div class="header">
                    <p>
                      Can View:<span v-for="(viewIndex, index) in activityDetails.canViewBy" :key="index">{{ viewIndex }},</span>
                    </p>
                  </div>
                </div>
                <div class="pb-10 col" v-if="activityDetails.timeToComplete">
                  <div class="content">
                    Approximate time to complete
                  </div>
                  <div class="header">{{ activityDetails.timeToComplete }} mins</div>
                </div>
              </div>
              <div class="pl-20 pb-15">
                <b-row class="pb-10 col" v-if="activityDetails.scheduler && activityDetails.scheduler.milestones">
                  <b-col v-if="activityDetails.scheduler && activityDetails.scheduler.milestones && activityDetails.scheduler.milestones.length > 0" class="p-0">
                    <div class="content">
                      To be completed at milestones
                    </div>
                    <div class="header">
                      <span v-for="(milestone, index) in activityDetails.scheduler.milestones" :key="index">
                        {{ milestone }}
                        <span v-if="index + 1 < activityDetails.scheduler.milestones.length">,</span>
                      </span>
                    </div>
                  </b-col>
                  <b-col v-if="activityDetails.scheduler.completionWindow">
                    <div class="content">
                      Completion window
                    </div>
                    <div class="header">{{ activityDetails.scheduler.completionWindow }} days</div>
                  </b-col>
                </b-row>
                <b-row class="pb-10 col" v-if="activityDetails.scheduler && activityDetails.scheduler.frequency">
                  <b-col class="p-0">
                    <div class="content">
                      Frequency
                    </div>
                    <div class="header">
                      {{ activityDetails.scheduler.frequency.title }}
                    </div>
                  </b-col>
                  <b-col v-if="activityDetails.scheduler.completionWindow" class="p-0">
                    <div class="content">
                      Completion window
                    </div>
                    <div class="header">{{ activityDetails.scheduler.completionWindow }} days</div>
                  </b-col>
                </b-row>
                <b-row class="pb-10 col" v-if="activityDetails.scheduler && activityDetails.scheduler.isActivityOptional">
                  <b-col class="p-0">
                    <div class="content">
                      Activity is optional and will be excluded from the compliance report.
                    </div>
                    <div class="header">
                      Yes
                    </div>
                  </b-col>
                </b-row>
                <b-row class="pb-10 col" v-if="activityDetails.scheduler && activityDetails.scheduler.allowMultipleTimes">
                  <b-col class="p-0">
                    <div class="content">
                      Allow participants to repeat survey each time it is present
                    </div>
                    <div class="header">
                      Yes
                    </div>
                  </b-col>
                </b-row>
                <b-row class="pb-10 col" v-if="activityDetails.scheduler && !(activityDetails.scheduler && activityDetails.scheduler.milestones && activityDetails.scheduler.milestones.length > 0) && activityDetails.scheduler.activitySchedulingMode !== 'onDemand'">
                  <b-col class="p-0">
                    <div class="content">
                      Available until the end of participant's study duration
                    </div>
                    <div class="header" v-if="activityDetails.scheduler.allowUntillDuration">
                      Yes
                    </div>
                    <div class="header" v-if="!activityDetails.scheduler.allowUntillDuration">
                      No
                    </div>
                  </b-col>
                </b-row>
                <b-row class="pb-10 col" v-if="activityDetails.watchEnabled">
                  <b-col class="p-0">
                    <div class="content">
                      Allow survey to be completed on an Apple Watch. Limited question types if selected.
                    </div>
                    <div class="header">
                      Yes
                    </div>
                  </b-col>
                </b-row>
                <div class="pb-10 col" v-if="questions.length !== 0">
                  <div class="content">Sent to:</div>
                  <div class="content" v-if="isRecipientFlagSet">
                    <b>Site Team</b>
                  </div>
                  <div v-if="emails.length > 0">
                    <div class="header" v-for="(item, index) in emails" :key="index">
                      {{ item.email }}
                    </div>
                  </div>
                  <div v-if="emails.length == 0 && !isRecipientFlagSet">
                    N/A
                  </div>
                </div>
                <b-row class="pb-10 col" v-if="activityDetails.scheduler && activityDetails.scheduler.duration">
                  <b-col cols="12" class="content p-0">
                    Scheduled as follows
                  </b-col>
                  <b-col class="p-0" cols="4" v-for="(item, index) in activityDetails.scheduler.duration" :key="index">
                    <b-row class="p-0">
                      <b-col class="p-0" cols="3" v-if="item.startDay">
                        <div class="content">
                          Start Day
                        </div>
                        <div class="header">
                          {{ item.startDay }}
                        </div>
                      </b-col>
                      <b-col class="p-0" cols="3" v-if="item.endDay">
                        <div class="content">
                          End Day
                        </div>
                        <div class="header">
                          {{ item.endDay }}
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="pb-10 col" v-if="activityDetails.scheduler && !(activityDetails.scheduler && activityDetails.scheduler.milestones && activityDetails.scheduler.milestones.length > 0)">
                  <b-col class="p-0" v-if="activityDetails.scheduler.allowUntillDuration">
                    <div class="content">
                      Available until the end of participant's study duration
                    </div>
                    <div class="header">
                      Yes
                    </div>
                  </b-col>
                </b-row>
                <b-row class="pb-10 col" v-if="activityDetails.scheduler && activityDetails.scheduler.reminders">
                  <b-col cols="12" class="content p-0">
                    Reminders
                  </b-col>
                  <b-col class="p-0" cols="12">
                    <b-row class="p-0">
                      <b-col class="p-0" cols="2">
                        <div class="content">
                          Day
                        </div>
                      </b-col>
                      <b-col class="p-0" cols="6">
                        <div class="content">
                          Message
                        </div>
                      </b-col>
                      <b-col class="p-0" cols="2">
                        <div class="content">
                          Time
                        </div>
                      </b-col>
                      <b-col class="p-0" cols="2">
                        <div class="content">
                          Notification type
                        </div>
                      </b-col>
                    </b-row>
                    <b-row class="p-0" v-for="(item, index) in activityDetails.scheduler.reminders" :key="index">
                      <b-col class="p-0" cols="2">
                        <div class="header">
                          {{ item.day }}
                        </div>
                      </b-col>
                      <b-col class="p-0" cols="6">
                        <div class="header" v-if="item.message">
                          {{ item.message }}
                        </div>
                      </b-col>
                      <b-col class="p-0" cols="2">
                        <div class="header" v-if="item.time">
                          {{ item.time }}
                        </div>
                      </b-col>
                      <b-col class="p-0" cols="2">
                        <div class="header">
                          <span>Mobile</span>
                          <span v-if="item.emailToggle">, Email</span>
                          <span v-if="item.smsToggle">, SMS Text</span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="content pb-10 col" v-if="activityDetails.prePopulationEnabled">
                  Show participant's their previous survey answers, if applicable. Only applies for this survey
                </b-row>
              </div>
            </div>
            <div class="col-md-5">
              <div class="activity-info mb-10">Activity Settings</div>
              <div class="pb-5">
                <label class="activity-setting-label">Ability to score responses</label>
                <span v-if="activityDetails.canScoreResponses == true">Enabled</span>
                <span v-else>Disabled</span>
              </div>
              <div class="pb-5">
                <label class="activity-setting-label">Allow site users to edit responses</label>
                <span v-if="activityDetails.allowDataEditChecks == true">Enabled</span>
                <span v-else>Disabled</span>
              </div>
              <div class="pb-5">
                <label class="activity-setting-label">Available for Apple Watch app</label>
                <span v-if="activityDetails.watchEnabled == true">Enabled</span>
                <span v-else>Disabled</span>
              </div>
              <div class="pb-5">
                <label class="activity-setting-label">Re-population with prior responses</label>
                <span v-if="activityDetails.prePopulationEnabled == true">Enabled</span>
                <span v-else>Disabled</span>
              </div>
              <div class="pb-5">
                <label class="activity-setting-label">Custom Participant Message</label>
                <span v-if="activityDetails.customParticipantMessaging == true">Enabled</span>
                <span v-else>Disabled</span>
              </div>
              <div class="pb-5">
                <label class="activity-setting-label">Hide Step Numbers</label>
                <span v-if="activityDetails.hideNumericLabels == true">Enabled</span>
                <span v-else>Disabled</span>
              </div>
              <div class="pb-5">
                <label class="activity-setting-label">Allow participant to save progress</label>
                <span v-if="activityDetails.allowSaveProgress == true">Enabled</span>
                <span v-else>Disabled</span>
              </div>
              <div class="pb-5">
                <label class="activity-setting-label">Enable progress indicators</label>
                <span v-if="activityDetails.enableProgressIndicator == true">Enabled</span>
                <span v-else>Disabled</span>
              </div>
              <div class="pb-5">
                <label class="activity-setting-label">Define devices for completion</label>
                <span v-if="activityDetails.allowDevicesForCompletion == true">Enabled</span>
                <span v-else>Disabled</span>
              </div>
              <div class="pb-5">
                <label class="activity-setting-label">Allow previous responses to be shown</label>
                <span v-if="activityDetails.allowPreviousResponses == true">Enabled</span>
                <span v-else>Disabled</span>
              </div>
            </div>
          </div>

          <div class="pl-10 pb-15 activity-questions-wrap" v-if="activityDetails.questions.length > 0">
            <div v-for="(question, index) in questions" :key="index">
              <div class="card read_only_question" v-if="question.type !== 'SurveyCompletion' && question.type !== 'Section'">
                <div class="row">
                  <div class="col-12 p-0">
                    <h5 class="font-style fs-16">
                      Screen
                      {{ question.stepSequence ? question.stepSequence : question.sequence }}
                    </h5>
                    <div v-if="question.type === 'SurveyInstruction' || question.type === 'GPSkin' || question.type === 'ImageCapture' || question.type === 'SkinAnalyser' || question.type === 'AudioRecording' || question.type === 'VideoRecording'" ref="formatted-information-container">
                      <div v-if="question.templateImageUrl">
                        <div class="row">
                          <div class="col-lg-6 col-md-6">
                            <h5 class="instructionTitle fs-14 ml-17" v-html="prepareQuestion(question.formattedBody, question.sequence)"></h5>
                            <p class="question_body fs-12" v-html="question.formattedInformation"></p>
                            <div class="row">
                              <div class="col-lg-6 col-md-6 pl-0 pr-20" v-if="question.previewImageUrl">
                                <img class="img-size" :src="question.previewImageUrl" />
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6 col-md-6">
                            <h5 class="instructionTitle fs-14 ml-17">
                              Template Image
                            </h5>
                            <div class="row">
                              <div class="col-lg-6 col-md-6 pl-0 pr-20" v-if="question.templateImageUrl">
                                <img class="img-size" :src="question.templateImageUrl" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div v-else-if="!question.templateImageUrl && question.formattedInformation && question.type !== 'SurveyInstruction'">
                        <div class="question_body_11 survey_content mb-10" v-html="prepareQuestion(question.formattedBody, question.sequence)"></div>
                        <div class="survey_heading fs-14 audio-content" v-html="question.formattedInformation"></div>
                        <div v-if="question.previewImageUrl">
                          <img :src="question.previewImageUrl" alt class="img-size" />
                        </div>
                      </div>

                      <div v-else>
                        <h5 class="instructionTitle fs-14" v-html="prepareQuestion(question.formattedBody, question.sequence)"></h5>
                        <span><div class="question_body fs-12 ml-20" v-html="question.formattedInformation"></div></span>
                        <div class="row">
                          <div class="col-lg-6 col-md-6 pl-0 pr-20" v-if="question.previewImageUrl">
                            <img class="img-size" :src="question.previewImageUrl" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="question-section">
                        <p class="question_body">
                          <span class="activity-flex-details" v-html="prepareQuestion(question.formattedBody, question.sequence)"></span>
                          <span class="ml-18" v-if="question.characterLimited">(Limit - {{ question.textLimit }})</span>
                        </p>
                        <div v-if="question.hasBodyImage">
                          <div v-for="(img, index) in question.bodyImages" :key="index">
                            <img :src="img.previewImageUrl" alt="" class="img-size" />
                          </div>
                        </div>
                      </div>
                      <div class="answer-section ml-18">
                        <div class="option-section" v-if="question.type.toLowerCase() === 'boolean'">
                          <div v-for="(option, index) in question.options" :key="index">
                            <p class="radio-option">
                              <input type="radio" name="boolean_type" disabled />
                              <label>{{ option.formattedBody }}</label>
                            </p>
                            <div v-if="questionIds[option.nextQuestion]">
                              <label class="pl-5"
                                >If this option is selected, skips to screen <b>{{ questionIds[option.nextQuestion] }}</b></label
                              >
                            </div>
                          </div>
                        </div>
                        <div v-if="question.type == 'WongBaker'">
                          <div class="row">
                            <div class="col-md-12 p-2">
                              <img width="100%" height="250px" src="static/img/activity-configurator/Wong_baker_black_face.jpg" class="wong-baker-smiley d-block text-center" alt="hurts-worse.svg" />
                              <div class="text-left pt-6 ql-editor p-0" v-html="question.formattedInformation" />
                            </div>
                          </div>
                        </div>
                        <div class="option-section pad-top20" v-if="question.type.toLowerCase() === 'numberscale'">
                          <ds-slider
                            v-if="!question.verticalScale"
                            ref="slider"
                            :value="question.minValue"
                            :piecewise="true"
                            direction="horizontal"
                            class="horizontal-vue-slider pl-20"
                            :min="question.minValue"
                            :max="question.maxValue"
                            :disabled="true"
                            :piecewiseLabel="true"
                            :piecewiseStyle="piecewiseStyle"
                            :interval="question.partitions"
                            :piecewiseActiveStyle="piecewiseActiveStyle"
                            :labelActiveStyle="labelActiveStyle"
                            :hideScale="question.hideScale"
                          ></ds-slider>
                          <ds-slider
                            v-if="question.verticalScale"
                            ref="slider"
                            :value="question.minValue"
                            :piecewise="true"
                            direction="vertical"
                            class="vertical-vue-slider pl-20"
                            width="2"
                            :min="question.minValue"
                            :max="question.maxValue"
                            :disabled="true"
                            :piecewiseLabel="true"
                            :piecewiseStyle="piecewiseStyle"
                            :interval="question.partitions"
                            :piecewiseActiveStyle="piecewiseActiveStyle"
                            :labelActiveStyle="labelActiveStyle"
                            :hideScale="question.hideScale"
                          ></ds-slider>
                        </div>
                        <div class="option-section pad-top20" v-if="question.type.toLowerCase() === 'customscale'">
                          <ds-slider
                            v-if="!question.verticalScale"
                            ref="slider"
                            :value="question.formattedLabels[0]"
                            :piecewise="true"
                            width="1"
                            direction="horizontal"
                            class="horizontal-vue-slider pl-20"
                            :data="question.formattedLabels"
                            :disabled="true"
                            :piecewiseLabel="true"
                            :piecewiseStyle="piecewiseStyle"
                            :piecewiseActiveStyle="piecewiseActiveStyle"
                            :labelActiveStyle="labelActiveStyle"
                          ></ds-slider>
                          <ds-slider v-if="question.verticalScale" ref="slider" :value="question.formattedLabels[0]" :piecewise="true" width="2" direction="vertical" class="vertical-vue-slider pl-20" :data="question.formattedLabels" :disabled="true" :piecewiseLabel="true" :piecewiseStyle="piecewiseStyle" :piecewiseActiveStyle="piecewiseActiveStyle" :labelActiveStyle="labelActiveStyle"></ds-slider>
                        </div>
                        <div class="option-section pad-top20" v-if="question.type && question.type.toLowerCase() === 'vas'">
                          <div v-if="!question.verticalScale">
                            <div v-if="activityData && activityData.newLayout == true">
                              <div class="row">
                                <div class="col-md-3 pr-10">
                                  {{ question.minValueLabel }}
                                </div>
                                <div class="col-md-6">
                                  <ds-slider ref="slider" :value="question.minValue" direction="horizontal" class="horizontal-vue-slider" :width="question.restrainLengthValue + 'mm'" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"> </ds-slider>
                                  <div class="pt-10 scaleLabels-vas">
                                    <span :style="{ 'margin-left': 15 + 'px' }">{{ question.minValue }}</span>
                                    <span class="pull-right">{{ question.maxValue }}</span>
                                  </div>
                                </div>
                                <div class="col-md-3">
                                  {{ question.maxValueLabel }}
                                </div>
                              </div>
                            </div>
                            <div v-else>
                              <div class="pt-10 scaleLabels-vas">
                                <div :style="{ 'margin-left': 15 + 'px' }">
                                  {{ question.minValueLabel }}
                                </div>
                                <div
                                  :style="{
                                    'margin-left': question.restrainLengthValue - 10 + 'mm'
                                  }"
                                >
                                  {{ question.maxValueLabel }}
                                </div>
                              </div>
                              <ds-slider ref="slider" :value="question.minValue" direction="horizontal" class="horizontal-vue-slider pl-20" :width="question.restrainLengthValue + 'mm'" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
                              <div class="pt-10 scaleLabels-vas">
                                <div :style="{ 'margin-left': 15 + 'px' }">
                                  {{ question.minValue }}
                                </div>
                                <div
                                  :style="{
                                    'margin-left': question.restrainLengthValue - 10 + 'mm'
                                  }"
                                >
                                  {{ question.maxValue }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="question.verticalScale">
                            <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ question.maxValue }}</span>
                            <span :style="{ 'margin-left': 30 + 'px' }" class="scaleLabels">{{ question.maxValueLabel }}</span>
                            <ds-slider ref="slider" :value="question.minValue" direction="vertical" class="vertical-vue-slider-vas pl-20" width="2" :height="question.restrainLengthValue + 'mm'" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="labelActiveStyle"></ds-slider>
                            <div class="scaleLabels" v-if="question.verticalScale">
                              <span :style="{ 'margin-left': 30 + 'px' }">{{ question.minValue }}</span>
                              <span :style="{ 'margin-left': 30 + 'px' }">{{ question.minValueLabel }}</span>
                            </div>
                          </div>
                        </div>
                        <div v-if="question.type == 'MedicationSelector'">
                          <div class="col-md-12 col-sm-12 col-12 p-0 pt-15" v-if="question.content != '[]' && question.content[0] != undefined && question.content[0]['options'] != undefined">
                            <div class="medication_selector_table_container">
                              <div class="row table_heading">
                                <div class="col-md-4 text-center border padding">
                                  Category
                                </div>
                                <div class="col-md-4 text-center border padding">
                                  Medication
                                </div>
                                <div class="col-md-4 text-center border padding">
                                  Dosage
                                </div>
                              </div>
                              <table class="medication_selector_table1">
                                <tbody>
                                  <span v-for="(option, ind) in question.content[0]['options']" :key="ind">
                                    <tr v-for="(dosage, index) in option['dosage']" :key="index">
                                      <td v-if="index == 0">
                                        {{ option["category"] }}
                                      </td>
                                      <td v-else-if="index == 1" :rowspan="option['dosage'].length - 1"></td>
                                      <td v-if="index == 0">
                                        {{ option["name"] }}
                                      </td>
                                      <td v-else-if="index == 1" :rowspan="option['dosage'].length - 1"></td>
                                      <td>{{ dosage }}</td>
                                    </tr>
                                  </span>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div class="option-section" v-if="question.type.toLowerCase() === 'text'">
                          <input type="text" class="input-text readonly ml-1" placeholder="" readonly />
                        </div>
                        <div class="option-section" v-if="question.type.toLowerCase() === 'datetime'">
                          <div class="col-sm-3 p-0" v-if="question.showDate">
                            <input type="text" class="input-text readonly" placeholder="" v-model="question.dateFormat" readonly />
                          </div>
                          <div class="col-sm-3 pt-3 pl-0" v-if="question.showTime">
                            <span v-if="question.timeFormat == '12'">
                              <input type="text" class="input-text readonly" placeholder="" value="--:-- AM" readonly />
                            </span>
                            <span v-if="question.timeFormat == '24'">
                              <input type="text" class="input-text readonly ml-1" placeholder="" value="--:--" readonly />
                            </span>
                          </div>
                        </div>
                        <div class="option-section" v-if="question.type.toLowerCase() === 'number'">
                          <div class="">
                            <input type="text" class="input-text readonly ml-1" placeholder="" readonly />
                            <div>
                              <label class="fw-normal display-block pt-10" v-if="question.hasUnits">
                                <span class="position_relative">Answer label: {{ question.units }}</span>
                              </label>
                              <label class="fw-normal display-block" v-if="question.hasMinMax">
                                <span class="position_relative"
                                  >Min/max value
                                  <span class="position_relative">{{ question.minValue }}</span>
                                  <span class="position_relative"> to {{ question.maxValue }}</span>
                                </span>
                              </label>
                              <label class="fw-normal display-block" v-if="question.allowDecimals">
                                <span class="position_relative">Allow decimals: {{ question.allowDecimals }}</span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div class="option-section" v-if="question.type.toLowerCase() === 'valuepicker'">
                          <div class="">
                            <input type="number" class="input-text readonly ml-1" placeholder="" readonly />
                          </div>
                        </div>
                        <div class="option-section" v-if="question.type.toLowerCase() === 'imagechoice'">
                          <div class=""></div>
                        </div>
                        <div class="option-section" v-if="question.type.toLowerCase() === 'email'">
                          <div class="">
                            <input type="email" class="input-text readonly ml-1" placeholder="" readonly />
                          </div>
                        </div>
                        <div class="option-section" v-if="question.type.toLowerCase() === 'location'">
                          <div class="">
                            <input type="text" class="input-text readonly ml-1" placeholder="" readonly />
                          </div>
                        </div>
                        <div class="option-section" v-if="question.type.toLowerCase() === 'multichoice'">
                          <div v-if="question.subType.toLowerCase() === 'multi'">
                            <div v-for="(option, index) in question.options" :key="index">
                              <div v-if="option.enabled">
                                <label> <input type="checkbox" disabled />&nbsp;<span v-html="splitPTagfromContent(option.formattedBody)"></span> </label>
                                <div v-if="option.previewImageUrl">
                                  <img :src="option.previewImageUrl" alt="" />
                                </div>
                                <div v-if="questionIds[option.nextQuestion]">
                                  <label class="pl-5"
                                    >If this option is selected, skips to screen <b>{{ questionIds[option.nextQuestion] }}</b></label
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="question.subType.toLowerCase() === 'single'">
                            <div v-for="(option, index) in question.options" :key="index">
                              <div v-if="option.enabled">
                                <label> <input type="radio" disabled />&nbsp;<span v-html="splitPTagfromContent(option.formattedBody)"></span> </label>
                                <div v-if="option.previewImageUrl">
                                  <img :src="option.previewImageUrl" alt="" class="" />
                                </div>
                                <div v-if="questionIds[option.nextQuestion]">
                                  <label class="pl-5"
                                    >If this option is selected, skips to screen <b>{{ questionIds[option.nextQuestion] }}</b></label
                                  >
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="option-section lang-img-options" v-if="question.type.toLowerCase() === 'image'">
                          <div class="row justify-content-start">
                            <div class="col-auto pl-0 pr-0" v-for="(langOptionobj, loopIndex) in question.languageImageOptions" :key="loopIndex">
                              <div class="language-name">
                                {{ langOptionobj.languageName }}
                              </div>
                              <div class="form-group clearfix" v-for="(option, optionIndex) in langOptionobj.options" :key="optionIndex">
                                <div v-if="option.enabled">
                                  <span v-if="question.subType.toLowerCase() === 'multi'">
                                    <input type="checkbox" id="checkbox" disabled />
                                  </span>
                                  <span v-else>
                                    <input type="radio" id="radio" disabled />
                                  </span>
                                  <img class="col-lg-2 img-size" :src="option.previewImageUrl" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="activity-branching">
                <branchingLogicQus :question="question" :questions="questions" />
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from "lodash";
import dsSlider from "../../../lib/ds-slider-component";
import branchingLogicQus from "../../activity-library/branching-logic.vue";
import { loadData } from "@/services/video-render";
/* 
  IMPORTANT
  Any changes made in this file should also be made in the survey.vue which is inside the study-details-pdf folder
   */
export default {
  name: "activity-details",
  data() {
    return {
      activityDetails: null,
      selectedActivity: {},
      studyId: this.$route.params.studyId,
      activityId: this.$route.params.activityId,
      piecewiseActiveStyle: {
        backgroundColor: "#3498db"
      },
      labelActiveStyle: {
        color: "#3498db"
      },
      piecewiseStyle: {
        backgroundColor: "#ccc",
        visibility: "visible",
        width: "12px",
        height: "12px"
      },
      questionIds: {},
      questions: [],
      emails: [],
      isRecipientFlagSet: false,
      qlVideoUpload: null
    };
  },
  components: { dsSlider, branchingLogicQus },
  methods: {
    prepareQuestion(q, i) {
      return i + '. <span style="margin-left: 2px;">' + q + "</span>"; 
    },
    splitPTagfromContent(text) {
      if (text == null) {
        return;
      }
      return text.replace("<p>", "").replace("</p>", "");
    },

    async getActivityDetails() {
      const participantFacingActivities = await this.getParticipantFacingActivities();
      const siteFacingActivities = await this.getSiteFacingActivities();
      this.mergeActivities(participantFacingActivities, siteFacingActivities);
    },
    getParticipantFacingActivities() {
      return this.$api.getStudyActivityDetailsFact(this.studyId).then(response => {
        return response.body;
      });
    },
    getSiteFacingActivities() {
      return this.$api.getSideFacingActivityDetailsFact(this.studyId).then(response => {
        return response.body;
      });
    },
    mergeActivities(participantFacingActivities, siteFacingActivities) {
      const allActivities = [...participantFacingActivities, ...siteFacingActivities];
      this.activityDetails = _.find(allActivities, ["id", this.activityId]);
      this.questions = this.activityDetails.questions;
    }
  },
  created() {
    this.getActivityDetails();
  },
  watch: {
    activityDetails: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          if (this.$refs["formatted-information-container"]) {
            this.$refs["formatted-information-container"].forEach(ele => {
              if (!ele.videoRendered) {
                loadData(ele);
                ele.videoRendered = true;
              }
            });
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.inner-card {
  border: none;
  margin: 5px 20px;
  border-radius: 3px !important;
  background-color: #d3dfe4;
}
.content {
  font-size: 12px;
  color: #666669;
}
.header {
  font-size: 12px;
  font-weight: bold;
  color: #666669;
}

.img-style {
  padding-top: 20px;
  height: 300px;
  width: 500px;
  padding-bottom: 20px;
}

.question_body {
  color: #959fa4;
}

.read_only_question {
  border-left: 8px solid #d3dfe4 !important;
  background-color: #f5f8fa;
  padding-left: 0px !important;
}

.icon-style {
  color: #57dd7a;
  font-size: 25px;
  padding-top: 20px;
  background-color: #d6f0de;
  padding: 7px;
  padding-bottom: 3px;
  border-radius: 25px;
}

.font-style {
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #3498db;
}

.text-style {
  color: #969090;
  text-align: right;
}

.btn-style {
  margin-top: 10px;
  width: 80px;
  height: 29px;
  margin-bottom: 50px;
}

.custom-btn {
  background: #00baf9;
  color: #fff;
  width: 220px;
}

.pad-top50 {
  padding-top: 50px;
}

.form-control {
  border-radius: 2px;
}

.custom-para {
  padding-bottom: 20px;
  font-size: 20px;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}
.readonly {
  background: #f7f7f7;
}
.btn-disabled {
  color: white;
  background-color: #c6c2c2;
  border: #c6c2c2;
}

.instructionTitle {
  color: #959fa4;
  display: flex;
  word-break: break-word;
}

.survey-name {
  color: #00baf9;
  font-size: 20px;
}

.pad-left50 {
  padding-left: 50px;
}
.branching_section {
  background-color: #f5f8fa;
  border: solid 1px #d3dfe4;
  padding: 5px 10px;
}
.branching_image {
  max-width: 120px;
  max-height: 120px;
  width: 100%;
  border: 1px solid #ccc;
}
.custom-btn-bg {
  background: linear-gradient(to left, #4b6fe6, #00baf9);
  color: #fff;
}

.mar-bot20 {
  margin-bottom: 20px;
}

.pad-left100 {
  padding-left: 100px;
}

.mar-bot0 {
  margin-bottom: 0px !important;
}

.card {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 15px;
  margin-bottom: 16px;
  background: #d3dfe4;
  border: #d3dfe4;
}

.question_color,
input {
  color: #666769;
  font-size: 14px;
}

.radio-option {
  margin: 0px 0px 0px 7px;
}

.input-text {
  width: 100%;
  border-radius: 2px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
  display: flex;
}

.date-input {
  border-radius: 20px;
  outline: none;
  border: 1px solid #ccc;
  height: 35px;
  text-indent: 10px;
}

.pad-top20 {
  padding-top: 20px;
}

.vertical-vue-slider {
  height: 300px !important;
  width: 4px;
  padding: 11px;
  margin-left: 30px;
}

.horizontal-vue-slider {
  height: 8px;
  width: 100%;
}

.img-size {
  width: 100%;
  height: auto;
  float: none;
  padding: 10px 0 0;
  max-width: 120px;
  max-height: 120px;
  box-sizing: content-box;
}

label {
  font-weight: normal !important;
  color: #959fa4;
}
.wid300 {
  max-width: 300px !important;
}

.img_size {
  width: 100%;
  height: 100%;
  max-width: 100px;
  max-height: 100px;
}

.lang-img-options .col-auto {
  margin-right: 66px !important;
}

.lang-img-options .col-auto:last-of-type {
  margin-right: 0 !important;
}

.language-name {
  color: #959fa4;
}

.activity-info {
  margin-top: 15px;
  font-size: 14px;
  color: #000000;
}
.activity-setting-label {
  width: 80%;
}
.outer-activity-study {
  display: flex;
}
.activity-flex-details {
  display: flex;
}
.activity-details-info div.col {
  padding: 0px;
}
.activity-branching {
  padding-left: 8px;
  box-sizing: border-box;
}
.activity-questions-wrap {
  border-top: 1px solid #f5f8fa;
}
.activity-detail-left {
  width: 100%;
}
/deep/ .audio-content {
  img {
    max-width: 120px;
    margin-top: 8px;
    max-height: 120px;
    width: 100%;
    height: auto;
  }
}

.group-scoring-section {
  padding: 2px;
  border-radius: 3px;
  border: solid 1px #b0bac9;
  background-color: #b0bac9;
  padding-left: 9px;
}

.group-scoring-section:first-of-type {
  margin-top: 10px;
}
</style>
